<section class="pb-3 pb-lg-8">
  <div class="row">
    <div class="col-12 col-lg-9">
      <ng-container>
        <div class="card min-h-60">
          @if (isLoading()) {

          <app-skeleton-details></app-skeleton-details>
          }@else if (notFound()) {
          <div class="card-body">
            <div class="empty-state" data-testid="course-not-found">
              <span class="empty-state__mark">
                <app-keenicon name="questionnaire-tablet" class="fs-2tx"></app-keenicon>
              </span>
              <p class="empty-state__title">{{ "APP.COURSE_NOT_FOUND" | translate }}</p>
              <p class="empty-state__body">{{ "APP.COURSE_NOT_FOUND_HINT" | translate }}</p>
              <a class="btn btn-primary" routerLink="/courses">{{ "MENU.COURSES" | translate }}</a>
            </div>
          </div>
          }@else {
          <app-course-description [data]="course_info">
            <section orderCard class="d-lg-none pt-6">
              <ng-container *ngTemplateOutlet="sideDrawer"></ng-container>
            </section>
            <section courseOptions class="d-lg-none pt-6">
              <ng-container *ngTemplateOutlet="orderFooter"></ng-container>
            </section>
          </app-course-description>

          }
        </div>

        <div class="card mt-8">
          <div class="card-header align-items-center py-5 gap-5">
            <div class="d-flex">
              <h1 class="mb-0 fw-semibold">
                {{ "APP.COURSE_REVIEWS" | translate }}
              </h1>
            </div>
          </div>

          <div class="card-body p-0">
            @if (isLoading()) {
            <div class="p-6 px-10">
              <app-skeleton-table-item></app-skeleton-table-item>
              <div class="separator my-10"></div>
              <app-skeleton-table-item></app-skeleton-table-item>
              <div class="separator my-10"></div>
              <app-skeleton-table-item></app-skeleton-table-item>
            </div>
            }@else {

            <app-review-table-widget [dataSource]="course_review" [isLoading]="tableLoading()" [dataTable]="true"
              (tableChange)="onTableChange($event)" [rowClick]="false">
            </app-review-table-widget>

            }
          </div>
        </div>
      </ng-container>
    </div>
    <div class="d-none d-lg-block col-3 pisition-relative">
      <section class="side-drawer">
        <ng-container *ngTemplateOutlet="sideDrawer"></ng-container>
      </section>
    </div>
  </div>
</section>

<ng-template #sideDrawer>
  @if (isLoading()) {
  <app-skeleton-right-side></app-skeleton-right-side>

  }@else{
  <div class="card card-flush h-xl-100 m-auto">
    <div class="card-body text-center p-8">
      <img [src]="course_info.image_url ? fileUrl + course_info.image_url : ''" [attr.alt]="course_info.name"
        class="col-12 mh-350px w-sm-auto w-lg-100 rounded-nested object-fit-cover object-position-top  mb-4" />
      <div class="d-flex flex-column gap-2 mt-2">

        <div class="d-flex flex-row flex-wrap align-items-end gap-2 text-start mb-1">
          <!-- "฿0.00" is what a broken price looks like. The catalogue card for
               the same course already says "เรียนฟรี"; the page you land on
               from it said nothing of the kind. -->
          @if (pricing().price > 0) {
          <span class="fw-bold fs-2x lh-1 d-block"
            [ngClass]="pricing().hasDiscount ? 'text-danger' : 'text-gray-800'">{{
            pricing().price
            |
            currency : "฿" }}</span>
          } @else {
          <span class="fw-bold fs-2x lh-1 d-block text-success">{{ "APP.FREE" | translate }}</span>
          }
          @if(pricing().hasDiscount){
          <span class="fw-semibold text-decoration-line-through text-gray-400 fs-5 lh-1 d-block">{{
            pricing().originalPrice |
            currency : " " }}</span>
          }
        </div>
        <div class="text-start">
          <span class="fw-bold text-gray-600 cursor-pointer fs-4 lh-1 d-block" data-testid="course-title">{{
            course_info.name }}</span>
        </div>


      </div>

      <!-- Pill on every button in this stack, not just the primary one — the
           same shape the course card's own "buy now" button already uses on
           the landing and catalogue pages, so the page you land on from a
           card doesn't switch to a different button language. `btn-light`
           (flat grey, bordered) on "add to cart" was also the odd one out
           tonally: it read as neutral or disabled rather than a real
           secondary action next to the tonal trial button. -->
      <div class="d-flex flex-column gap-4 pt-6">
        <button type="button" class="btn btn-primary rounded-pill w-100 fw-bold fs-6" data-testid="enroll-now"
          (click)="addCart(course_info.id, true)">
          {{ "APP.ENROLL" | translate }}
        </button>

        <button type="button" class="btn btn-light-primary rounded-pill w-100 fw-bold fs-6" data-testid="add-cart"
          (click)="addCart(course_info.id)">
          {{ "APP.ADD_CART" | translate }}
        </button>

        <!-- Free trial. Only offered when the course actually exposes a preview
             video: the API refuses otherwise, and a button that always fails is
             worse than no button. -->
        @if (course_info.has_trial_videos) {
        <button type="button" class="btn btn-light-success rounded-pill w-100 fw-bold fs-6" data-testid="start-trial"
          [disabled]="trialLoading()" (click)="startTrial(course_info.id)">
          {{ trialLoading() ? ("APP.TRIAL_STARTING" | translate) : ("APP.FREE_TRIAL" | translate) }}
        </button>
        }
      </div>

      @if(!currentUser() ){
      <span class="text-center text-gray-600 fs-6 fw-semibold d-block pt-6">
        {{ "AUTH.REGISTER.NOT_REGISTER" | translate }}
        <u class="text-primary cursor-pointer" (click)="openRegisterDialog()">
          {{ "AUTH.REGISTER.TITLE" | translate }}
        </u>
      </span>
      }
    </div>

    <div class="card-footer d-none d-lg-block pt-0">
      <ng-container *ngTemplateOutlet="orderFooter"></ng-container>
    </div>
  </div>

  }
</ng-template>

<ng-template #orderFooter>
  <div class="text-gray-800 border-bottom border-2 border-primary py-2 pe-4 fs-4 fw-semibold">
    {{ "APP.COURSE_OPTIONS" | translate }}
  </div>

  <section #courseProperties class="mt-4 d-flex flex-column gap-3 fs-6 fw-normal">
    <div class="d-flex flex-row gap-3">
      <app-keenicon class="fs-2" name="calendar"></app-keenicon>
      <span>
        {{ "APP.DURATION" | translate }}
        <span>{{
          course_info.duration_time
          ? (course_info.duration_time | durationTime)
          : ("APP.NO_EXPIRATION" | translate)
          }}</span>
      </span>
    </div>
    <div class="d-flex flex-row gap-3">
      <app-keenicon class="fs-2" name="youtube"></app-keenicon>
      <span>
        {{ "APP.COURSE_VIDEO" | translate }}
        <span>{{
          course_info.duration_video
          ? (course_info.duration_video | durationVideo)
          : ("APP.NO_DURATION" | translate)
          }}</span>
      </span>
    </div>
    @if(course_info.duration_video_extra){
    <div class="d-flex flex-row gap-3">
      <app-keenicon class="fs-2" name="time"></app-keenicon>
      <span>
        {{ "APP.VIDEO_DURATION_EXTRA" | translate }}

        <span>{{ course_info.duration_video_extra }} %</span>
      </span>
    </div>
    }
    @if(course_info?.course_file_count){
    <div class="d-flex flex-row  gap-3">
      <app-keenicon class="fs-2" name="tablet-book"></app-keenicon>
      <span> {{ "APP.PDF_FILE" | translate }} {{course_info.course_file_count}} {{'APP.FILE_AMOUNT' |
        translate}}</span>
    </div>
    }

    <div class="d-flex flex-row gap-3">
      <app-keenicon class="fs-2" name="file"></app-keenicon>
      <span> {{ "APP.EXAMPLE" | translate }} </span>
    </div>
    <!-- "มีการจัดส่งสินค้า" was here, unconditional, with a blinking red dot on
         it: a hard-coded Thai literal piped through `translate` (so it could
         never be translated), on every course, on a platform that ships
         nothing but video. It was the loudest line in the buy box and the only
         untrue one. -->
  </section>

  <!-- Its own section, not a row in "สิ่งที่มีในคอร์ส" — a small muted label
       above the button, same treatment as other section micro-labels on the
       site, and the same button rank the buy box's other secondary actions
       already use elsewhere (`btn-light-primary rounded-pill`), so neither
       piece introduces a new, one-off style next to them. -->
  <div class="separator my-5"></div>

  <section class="d-flex flex-column justify-content-center align-items-center gap-3">
    <p class="text-center text-gray-600 fs-7 fw-medium text-uppercase ls-1 mb-0">
      {{ "APP.SHARE_COURSE" | translate }}
    </p>
    <button type="button"
      class="btn w-100 btn-light-primary rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 px-4"
      data-testid="copy-course-link" (click)="copyLink()">
      @if (linkCopied()) {
      <app-keenicon class="fs-3" name="check svg svg-icon"></app-keenicon>
      <span>{{ "APP.COPY_LINK_DONE" | translate }}</span>
      } @else {
      <app-keenicon class="fs-3" name="copy svg svg-icon"></app-keenicon>
      <span>{{ "APP.COPY_LINK" | translate }}</span>
      }
    </button>
  </section>
</ng-template>